<template>
  <svg
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.643 10.9529C4.26812 10.3278 5.11596 9.97662 6.00002 9.97662H10C10.8841 9.97662 11.7319 10.3278 12.357 10.9529C12.9822 11.5781 13.3334 12.4259 13.3334 13.31V14.6433C13.3334 15.0115 13.0349 15.31 12.6667 15.31C12.2985 15.31 12 15.0115 12 14.6433V13.31C12 12.7795 11.7893 12.2708 11.4142 11.8957C11.0392 11.5207 10.5305 11.31 10 11.31H6.00002C5.46959 11.31 4.96088 11.5207 4.58581 11.8957C4.21073 12.2708 4.00002 12.7795 4.00002 13.31V14.6433C4.00002 15.0115 3.70154 15.31 3.33335 15.31C2.96516 15.31 2.66669 15.0115 2.66669 14.6433V13.31C2.66669 12.4259 3.01788 11.5781 3.643 10.9529Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.00002 3.30996C6.89545 3.30996 6.00002 4.20539 6.00002 5.30996C6.00002 6.41453 6.89545 7.30996 8.00002 7.30996C9.10459 7.30996 10 6.41453 10 5.30996C10 4.20539 9.10459 3.30996 8.00002 3.30996ZM4.66669 5.30996C4.66669 3.46901 6.15907 1.97662 8.00002 1.97662C9.84097 1.97662 11.3334 3.46901 11.3334 5.30996C11.3334 7.15091 9.84097 8.64329 8.00002 8.64329C6.15907 8.64329 4.66669 7.15091 4.66669 5.30996Z"
    />
  </svg>
</template>
